<template>
  <div >
      <div :class="[isSharePage?'personalDetail':'personalDetailShare']">
        <div class="offset"></div>
        <div v-if="isShowBack" class="back" @click="btnBack"></div>

        <div class="personalBox">
        </div>

<!--        头像、姓名-->
        <div class="dw headIconAndUserNameBox">
          <div class="headIcon" :style="{backgroundImage:'url('+personJoinInfo.userImg+')'}" ></div>
          <div class="userName">{{personJoinInfo.fullName}}</div>
        </div>

<!--        用户信息-->
        <div class="dw userLabInfo">
          <div class="clear-fix" style="position: relative">
            <div v-if="isZhuanJia">
              <div class="labTip" >{{ getSex }}</div>
              <div class="labTip" v-if="getJoyTitle!=''">{{ getJoyTitle }}</div>
            </div>
            <div v-else>
              <div class="labTip" >{{ personJoinInfo.schoolName }}</div>
              <div class="labTip" >{{ getBanJi }}</div>
              <div class="labTip" >{{ getAge }}岁</div>
            </div>
          </div>
        </div>

<!--        活动信息-->
        <div class="dw actInfo" :style="{backgroundImage:'url('+title.activityLogo+')'}">
          <div class="title"><span>正在参加《{{ title.activityTitle }}》</span></div>
          <div class="title2"><span>参赛编号：{{ personJoinInfo.id }}</span></div>
        </div>

        <!--    视频播放区-->
        <div class="video dw">
<!--          <mgVideo :videoUrl=personJoinInfo.video :posterUrl=personJoinInfo.videoImage></mgVideo>-->
<!--          <mediaPlayer class="mediaPlayer" :sourceUrl="personJoinInfo.video" :posterUrl="personJoinInfo.videoImage"></mediaPlayer>-->
          <myMediaPlayer class="mediaPlayer"
                          ref="myVideo2"
                          :isLogo="true"
                         :isLookBack="false"
                         :src="personJoinInfo.video"
                         :poster="personJoinInfo.videoImage">
          </myMediaPlayer>

        </div>

        <!--    视频说明-->
        <div class="explan dw clear-fix">
          <p>
            {{ personJoinInfo.videoExplain }}</p>
        </div>

        <slot name="foot"></slot>
        <div v-if="isSharePage" style="width: 100%; height: 1rem"></div>

        <!--    广告位-->
        <div class="advert" v-if="isSharePage" v-show="advertArr.length!=0">
          <van-swipe class="advert_img"  :autoplay="10000" :show-indicators="false" lazy-render @change="onVanSwipeChange">
            <van-swipe-item class="advert_sub_img" v-for="image in advertArr" :key="image.img">
              <img @click="imgPreview" style="width: 100%; height: 100%" :src="image.img" />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
<!--    推荐信息-->
    <homeRecommend v-if="isSharePage"></homeRecommend>
  </div>
</template>

<script>
import {actUtil} from "../../../js/activity/util";
import mediaPlayer from "../../../components/common/mediaPlayer/mediaPlayer";
import homeRecommend from "../../ recommend/homeRecommend";
import {apiSys} from "../../../network/app/sys";
import Fingerprint2 from "fingerprintjs2";
import myMediaPlayer from "../../../components/myMediaPlayer/myMediaPlayer";

export default {
  name: "personalDetail",
  components:{
    mediaPlayer,
    myMediaPlayer,
    homeRecommend
  },
  data(){
    return{
      murmur: '', //指纹
      ostype: 'web',
      src: "",
      src2: "",

      vanSwipeIndex: 0,
      advertArr: [
        // {
        //   'img': "https://kepu.oss.toodo.com.cn/activity/advert/jd1.jpg",
        //   'link': "https://u.jd.com/Jtkjij6",
        // },
        {
          'id': 0,
          'img': "https://kepu.oss.toodo.com.cn/activity/advert/td1.jpg",
          'link': "https://a.app.qq.com/o/simple.jsp?pkgname=com.toodo.popularization&fromcase=40002",
        },
      ],
      // images: [
      //   "https://kepu.oss.toodo.com.cn/activity/advert/jd1.jpg",
      //   "https://kepu.oss.toodo.com.cn/activity/advert/m1.jpg",
      //   "https://kepu.oss.toodo.com.cn/activity/advert/m2.jpg",
      //   "https://kepu.oss.toodo.com.cn/activity/advert/td1.jpg",
      // ],
      // advertLink: [
      //   "https://u.jd.com/Jtkjij6",
      //   "",
      //   "",
      //   "https://a.app.qq.com/o/simple.jsp?pkgname=com.toodo.popularization&fromcase=40002",
      // ],
    }
  },
  props:{
    isSharePage:{
      type: Boolean,
      default: false
    },
    isShowBack:{
      type: Boolean,
      default: false
    },
    personJoinInfo: {
      type: Object
    },
    title:{
      type: Object,
      default: {}
    }
  },
  computed:{
    getBanJi(){
      return actUtil.toGradeString(this.personJoinInfo.grade)
    },
    getAge(){
      return actUtil.toAge(this.personJoinInfo.birthday)
    },
    getVoteCount(){
      return this.personJoinInfo.voteNum
    },
    isZhuanJia(){
      if((this.personJoinInfo.userIdentity==3)
        ||(this.personJoinInfo.userIdentity==4)){
        return true
      }else{
        return false
      }
    },
    getSex(){
      if(this.personJoinInfo.userSex==1){
        return '男'
      }else{
        return '女'
      }
    },
    getJoyTitle(){
      return this.personJoinInfo.jobTitle
    }

  },
  created() {
    console.log('personalDetail create');
    // document.documentElement.scrollTop = 0;

    // this.ostype = this.detectOS()
    this.createFingerprint()


    //广告信息获取
    setTimeout(()=>{
      this.getAppAds()
    },300)


  },
  mounted() {
    window.scrollTo(0,0);

  },
  destroyed() {
    console.log('personalDetail destroyed');
  },
  methods:{
    detectOS() {
      var sUserAgent = navigator.userAgent;
      // alert(navigator.platform)
      var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
      var isMac = (navigator.platform == "iPhone") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
      if (isMac) return "Mac";
      var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
      if (isUnix) return "Unix";
      var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
      if (isLinux) return "Linux";
      if (isWin) {
        var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
        if (isWin2K) return "Win2000";
        var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
        if (isWinXP) return "WinXP";
        var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
        if (isWin2003) return "Win2003";
        var isWin2003 = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
        if (isWin2003) return "WinVista";
        var isWin2003 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
        if (isWin2003) return "Win7";

        return navigator.platform
      }
      return "web";
    },
    getItem(item){
      let obj = {}
      obj.id = item.id
      obj.img = item.img
      obj.link = item.content
      if(item.img==''){
        return null
      }
      return obj
    },
    createFingerprint() {
      // 浏览器指纹
      const fingerprint = Fingerprint2.get((components) => {
        // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
        const values = components.map((component) => component.value) // 配置的值的数组
        const murmur = Fingerprint2.x64hash128(values.join(''), 31) // 生成浏览器指纹
        // console.log(components, values,murmur,'你好')
        //murmur就是浏览器指纹啦
        this.murmur = murmur
        // alert(murmur)
      })
    },
    randomRange(min, max) { // min最小值，max最大值
      return Math.floor(Math.random() * (max - min)) + min;
    },
    getAppAds(){
      let obj = {
        start:0,   //偏移       (Integer) (可选)
        limit:5,   //条数     (Integer) (可选)
        position:1     //位置: 1 活动首页顶部      (integer)
      }
      apiSys.getAppAds(obj).then(res=>{
        // console.log("广告位")
        // console.log(res);
        this.advertArr.length=0;
        let i = this.randomRange(0, res.length);
        for (; i<res.length; i++){
          let retObj = this.getItem(res[i])
          if(retObj!=null){
            this.advertArr.push(retObj)
            break
          }
        }
        //广告展现上报
        if(this.advertArr.length!=0){
          let showobj = {
            'adsId':this.advertArr[0].id,   //广告id  (integer)
            'deviceId':this.murmur,   //设备id       (string)
            'devOs':this.ostype     //设备系统 android ios       (string)
          }
          apiSys.showAppAds(showobj).then(res=>{

          })
        }

      }).catch(err=>{
        console.log(err);
      }).finally(()=>{})
    },
    btnBack(){
      this.$emit('back',null)
    },
    onVanSwipeChange(index){
      // console.log('onVanSwipeChange:'+index)
      this.vanSwipeIndex = index
    },
    imgPreview(){
      // console.log('imgPreview***'+this.advertArr.length)
      // ImagePreview(this.images, );
      if(this.vanSwipeIndex>this.advertArr.length){
        this.vanSwipeIndex = 0
      }

      if(this.advertArr[this.vanSwipeIndex].link!=''){
        let showobj = {
          'adsId':this.advertArr[0].id,   //广告id  (integer)
          'deviceId':this.murmur,   //设备id       (string)
          'devOs':this.ostype     //设备系统 android ios       (string)
        }
        apiSys.clickAppAds(showobj).then(res=>{

        })
        setTimeout(()=>{
          window.location.href = this.advertArr[this.vanSwipeIndex].link
        }, 300)

      }else{
        // ImagePreview({
        //   images: this.images_view,
        //   startPosition: this.vanSwipeIndex,
        //   closeable: true,
        // })
      }
    },
  }
}
</script>

<style scoped>
.offset{
  width: 100%;
  height:2px;
}
.personalDetail{
  /*background-color: #23232d;*/
  margin: auto;
  position: relative;
  /*z-index: 2;*/
}
.personalDetailShare{
  /*background-color: #23232d;*/
  position: relative;
  /*min-height: 100vh;*/
  /*z-index: 2;*/
}
.dw{
  width: 990px;
  margin: auto;
}
.personalBox{
  position: absolute;
  top: 0;
  width: 100%;
  height: 700px;
  /*background-image: linear-gradient(to bottom, #2a80ed, var(--color-background));*/
  background-image: linear-gradient(to bottom,#2a80ed, #2a80ed 75%, var(--color-background));
  z-index: 0;
}
.headIconAndUserNameBox{
  position: relative;
  height: 100px;
  /*background-color: #ead287;*/
  margin-top: 40px;
}
.headIcon{
  position: relative;
  float: left;
  width: 100px;
  height: 100px;
  border-radius: 100px;
  background-color: #666666;
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 2;
}
.userName{
  position: relative;
  float: left;
  margin-left: 40px;
  width: 600px;
  line-height: 100px;
  font-size: 50px;
  color: whitesmoke;
}
.userLabInfo{
  position: relative;
  /*min-height: 60px;*/
  /*background-color: #ead287;*/
  /*margin-top: 20px;*/
}
.labTip{
  float: left;
  margin-top: 20px;
  margin-right: 20px;
  padding: 4px;
  padding-left: 40px;
  padding-right: 40px;
  background-color: rgba(250,250,250,0.5);
  font-size: 40px;
  border-radius: 10px;
  color: whitesmoke;
}
.actInfo{
  position: relative;
  margin-top: 20px;
  min-height: 180px;
  /*background-color: #ead287;*/
  /*margin-top: 20px;*/
  background-size: 100px 100px;
  background-repeat: no-repeat;
  background-position: 40px center;
  background-color: rgba(250,250,250,0.5);
  font-size: 30px;
  border-radius: 10px;
  color: whitesmoke;
  letter-spacing: 2px;
}
.actInfo .title{
  position: relative;
  width: 800px;
  margin-left: 180px;
  padding-top: 40px;
}
.actInfo .title2{
  position: relative;
  width: 800px;
  margin-left: 180px;
  margin-top: 20px;
  padding-bottom: 40px;
}
.actInfo .title2 span{
  background-color: #589df6;
  padding: 6px;
  padding-left: 35px;
  padding-right: 35px;
  border-radius: 30px;
}

.back{
  margin-left: 45px;
  width: 140px;
  height: 44px;
  background-image: url("../../../assets/act001/personBack.png");
  background-size: 23px 40px;
  background-repeat: no-repeat;
  background-position: left center;
  z-index: 2;
}

.video{
  position: relative;
  margin-top: 40px;
  height: 556px;
  /*background-color: #3c3d41;*/
  /*object-fit: contain;*/
}
.mediaPlayer{
  position: relative;
  width: 100%;
  height: 556px;
  /*object-fit: cover;*/
}
.explan{
  margin-top: 25px;
  margin-bottom: 25px;
  /*background-color: #ff5777;*/
}
.explan p{
  float: left;
  /*width: 990px;*/
  text-indent: 2em;
  font-size: 40px;
  line-height: 70px;
  color: #3c3d41;
  white-space:normal;
  word-break:break-all;
}

.advert{
  width: 100%;
  height: 440px;
  /*background-color: #ead287;*/
}
.advert_img{
  margin: auto;
  width: 990px;
  height: 440px;
  /*background-image: url("../../assets/act001/logo.png");*/
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  /*margin-bottom: 100px;*/
  /*background-color: #ee0a24;*/
}
</style>

